import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DashboardLayout from "../../components/DashboardLayout";
import {
  getUniformForm,
  listUniformFormEmployees,
  updateUniformForm,
  listUniformTypes,
} from "../../services/uniformFormApi";
const empty = {
  employeeId: "",
  employeeCode: "",
  employeeName: "",
  designation: "",
  gender: "",
  mobile: "",
  uniformType: "",
  size: "",
  quantity: 1,
  reason: "",
  remarks: "",
};
const UniformFormEdit = () => {
  const { id } = useParams(),
    nav = useNavigate(),
    [f, setF] = useState(empty),
    [emps, setEmps] = useState([]),
    [types, setTypes] = useState([]),
    [empSearch, setEmpSearch] = useState(""),
    [loading, setLoading] = useState(!!id),
    [saving, setSaving] = useState(false);
  useEffect(() => {
    listUniformTypes(nav)
      .then((r) => setTypes(r.data || []))
      .catch(() => {});
    if (id) {
      setLoading(true);
      getUniformForm(id, nav).then((r) => {
        const data = r.data || {};
        setF({ ...empty, ...data, employeeId: data.employeeId || "" });
        listUniformFormEmployees(
          { outletId: data.outletId, search: empSearch },
          nav,
        )
          .then((x) => setEmps(x.data || []))
          .catch(() => {});
      }).catch((err) => alert(err.message)).finally(() => setLoading(false));
    }
  }, [id]);
  useEffect(() => {
    const t = setTimeout(() => {
      listUniformFormEmployees({ outletId: f.outletId, search: empSearch }, nav)
        .then((r) => setEmps(r.data || []))
        .catch(() => {});
    }, 300);
    return () => clearTimeout(t);
  }, [empSearch, f.outletId]);
  const ch = (e) => setF({ ...f, [e.target.name]: e.target.value });
  const emp = (e) => {
    const v = e.target.value,
      o = emps.find((x) => String(x.id) === v);
    setF({
      ...f,
      employeeId: v,
      employeeCode: o?.employeeCode || "",
      employeeName: o?.name || "",
      designation: o?.designation || "",
      gender: o?.gender || "",
      mobile: o?.mobile || "",
    });
  };
  const submit = async (e) => {
    e.preventDefault();
    if (saving) return;
    setSaving(true);
    try {
      await updateUniformForm(id, f, nav);
      nav("/uniform-forms");
    } catch (err) {
      alert(err.message);
      setSaving(false);
    }
  };
  return (
    <DashboardLayout title={id ? "Edit Uniform Form" : "Add Uniform Form"}>
      <div className="container-fluid">
        <div className="card p-4">
          <h3>{id ? "Edit" : "Add"} Uniform Form</h3>
          {loading ? <div className="text-center py-4"><span className="spinner-border spinner-border-sm me-2"/>Loading...</div> : <form onSubmit={submit}>
            <div className="row g-3">
              <div className="col-md-6">
                <label>Employee Search</label>
                <input
                  className="form-control mb-2"
                  placeholder="Search employee code, name, or mobile"
                  value={empSearch}
                  onChange={(e) => setEmpSearch(e.target.value)}
                />
                <select
                  className="form-select"
                  value={f.employeeId || ""}
                  onChange={emp}
                >
                  <option value="">Manual / Select Employee</option>
                  {emps.map((e) => (
                    <option key={e.id} value={e.id}>
                      {e.employeeCode} - {e.name}
                    </option>
                  ))}
                </select>
              </div>
              {[
                "employeeCode",
                "employeeName",
                "designation",
                "gender",
                "mobile",
              ].map((k) => (
                <div className="col-md-6" key={k}>
                  <label>{k}</label>
                  <input
                    className="form-control"
                    name={k}
                    value={f[k] || ""}
                    onChange={ch}
                    required={k === "employeeName"}
                  />
                </div>
              ))}
              <div className="col-md-6">
                <label>Uniform Type</label>
                <select
                  required
                  className="form-select"
                  name="uniformType"
                  value={f.uniformType || ""}
                  onChange={ch}
                >
                  <option value="">Select</option>
                  {types.map((x) => (
                    <option key={x.id} value={x.name}>
                      {x.name}
                    </option>
                  ))}
                </select>
              </div>
              {["size", "quantity", "reason", "remarks"].map((k) => (
                <div className="col-md-6" key={k}>
                  <label>{k}</label>
                  <input
                    className="form-control"
                    name={k}
                    type={k === "quantity" ? "number" : "text"}
                    value={f[k] || ""}
                    onChange={ch}
                  />
                </div>
              ))}
            </div>
            <button className="btn btn-primary mt-3" disabled={saving}>{saving&&<span className="spinner-border spinner-border-sm me-2"/>}{saving?"Saving...":"Save Draft"}</button>
            <button
              type="button"
              className="btn btn-outline-secondary mt-3 ms-2"
              onClick={() => nav("/uniform-forms")}
            >
              Cancel
            </button>
          </form>}
        </div>
      </div>
    </DashboardLayout>
  );
};
export default UniformFormEdit;
